import * as React from 'react';
import classnames from '../_virtual/index.js';
import { Skeleton } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const WishlistLoader = ({ className  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "wishlist-loader"
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames('wishlist-loader__skeleton', className)
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        height: 16,
        width: "100%",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        height: "16",
        rx: "5",
        fill: "currentColor"
    }))));
};

export { WishlistLoader as default };
//# sourceMappingURL=WishlistLoader.js.map
